import { render, staticRenderFns } from "./FeriadoForm.vue?vue&type=template&id=2498ac98"
import script from "./FeriadoForm.vue?vue&type=script&lang=js"
export * from "./FeriadoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports